import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Dialog, DialogContent, DialogTitle, Typography} from "@material-ui/core";
import request from "../../../../../../../../../../Services/API/Requests";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import {ScreenDesignerContextNew} from "../../../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import {useSelector} from "react-redux";
import getValueByString from "../../../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";

const PickImage = ({label, setValue, path}) => {
    const {screenValues} = useContext(ScreenDesignerContextNew)
    const [isOpen, setIsOpen] = useState(false);
    const imageObject = getValueByString(screenValues, path);
    function fileUpload(e) {
        let files = e.target.files;
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            // Make new FileReader
            let reader = new FileReader();
            // Convert the file to base64 text
            reader.readAsDataURL(file);
            // on reader load something...
            reader.onload = async () => {
                // Make a fileInfo Object

                let fileObject = {
                    name: file.name,
                    type: 'screenImage',
                    refEntity: 'screen',
                    content: reader.result,
                    refId: screenValues.id
                }

                try {
                    await request({
                        url: 'files/create',
                        data: fileObject
                    })
                } catch (e) {

                }
            }
        }
    }
    function setImageObject(imageObject) {
        setValue(imageObject, `${path}`)
    }

    return (
        <div style={{display: 'flex'}}>
            <div style={{width: 102}}>{label}</div>
            <div style={{width: 20}}>
                <Button variant={'outlined'}
                        onClick={() => setIsOpen(prev => {
                            return !prev
                        })}
                        style={{margin: '5px 5px 5px 0'}}
                        size={"small"}
                        color={"primary"}
                        component="span">
                    Pick
                </Button>
                <div>
                    {imageObject ? imageObject.id : ""}
                </div>
            </div>
            <ImageGalleryDialog
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                fileUpload={fileUpload}
            >
                <ImageGalleryContent
                    setImageObject={setImageObject}
                />
            </ImageGalleryDialog>
        </div>
    )
};

PickImage.propTypes = {
    label: PropTypes.string,
    setImageContent: PropTypes.func
};

export default PickImage;


const ImageGalleryDialog = ({isOpen, onClose, children, fileUpload}) => {
    return (
        <Dialog open={isOpen}
                onClose={onClose}
                fullWidth
                maxWidth={"md"}
        >
            <DialogTitle>
                <Typography color={"textSecondary"}
                            variant={"subtitle1"}
                >
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <div>
                            <Typography>Image Screen Gallery</Typography>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <Typography>Upload New Image</Typography>
                            <div style={{width: 20}}>
                                <input id="uploadFile"
                                       type="file"
                                       name='uploadFile'
                                       onChange={(e) => fileUpload(e)}
                                       style={{
                                           width: '0.1px',
                                           height: '0.1px',
                                           opacity: 0,
                                           overflow: 'hidden',
                                           position: 'absolute',
                                           zIndex: -1
                                       }}
                                />
                                <label htmlFor="uploadFile">
                                    <IconButton variant={'outlined'}
                                            size={"small"}
                                            color={"primary"}
                                            component="span">
                                        <Icon>
                                            upload
                                        </Icon>
                                    </IconButton>

                                </label>
                            </div>
                        </div>
                    </div>

                </Typography>
            </DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
        </Dialog>
    )
};

const ImageGalleryContent = ({setImageObject}) => {
    const [pageNumber, setPageNumber] = useState(0);
    const {appEnv} = useSelector(state => state.app)
    const [images, setImages] = useState([]);

    useEffect(() => {
        async function getImages() {
            const res = await request({
                url: 'list/getData',
                data: {
                    id: 'filesDefaultList',
                    advancedFilter: [
                        {field: 'refEntity', operand: 'equal', value: 'screen'}
                    ],
                    pageNumber,
                    sortFields: [{field: 'id', direction: 'DESC'}]
                }
            });
            setImages(res.content)
        }
        getImages()
    }, [pageNumber])

    const memoList = React.useMemo(() => images.map((image) => {
        const publicUrl = process.env.NODE_ENV === 'development' ?
            `${process.env.REACT_APP_REMOTE_HOST}${appEnv}${image.url}` :
            `/${appEnv}` + image.url;
        return <>
            <ImageComponent
            imgId={image.id}
            publicUrl={publicUrl}
            relativeUrl={image.url}
            setImageObject={setImageObject}
        />
            <p>{image.id}</p>
            </>
    }), [images])
    return (
        <>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                {memoList}
            </div>
            <div style={{
                display: 'flex', height: 40, padding: 5,
                border: '1px solid #f1f1f1',
                alignItems: 'center', justifyContent: 'flex-end'}}
            >
                <div style={{display: 'flex'}}>
                    <Button size={"small"}
                            variant={"outlined"}
                            onClick={() => {
                        setPageNumber(prev => prev - 1);
                    }}>Prev</Button>
                    <Button
                        size={"small"}
                        style={{marginLeft: 10}}
                        variant={"outlined"}
                        onClick={() => {
                        setPageNumber(prev => prev + 1);
                    }}>Next</Button>
                </div>
            </div>
        </>

    )
}

const ImageComponent = ({imgId, setImageObject, publicUrl, relativeUrl}) => {
    const [content, setContent] = useState('');
    useEffect(() => {
        async function getImage() {
            const res = await request({
                url: 'files/getFiles',
                data: {id: imgId}
            });
            setContent(res.content)
        }

        !publicUrl && getImage()
    }, [imgId, publicUrl])

    return (
        <div style={{
            width: '20%', height: '130px',
            border: '1px solid #f1f1f1', borderRadius: '3px',
            margin: 5, overflow: 'hidden',
            background: 'rgba(225,225,225,0.61)'
        }}
             onDoubleClick={() => setImageObject({url: relativeUrl, id: imgId})}
             onClick={() => console.log(imgId, relativeUrl)}
        >
            <img src={publicUrl ?  publicUrl : content} width={'100%'} alt={''}/>
        </div>
    )
}
